import React, { useContext, useState } from 'react';
import { TabPane, Tab, Button } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import { UserContext } from '../../app/layout/App';

const EnglishPane = () => {
  const [expanded, setExpanded] = useState(false);
  return (
    <TabPane attached={false} loggedIn>
      <h5>Mapping land conflicts in Timor Leste</h5>
      {!expanded ? (
        <>
          <p>
            Land disputes remain a serious challenge in Timor-Leste, particularly for rural and marginalized communities.
            Civil society organizations play an important role in advocating for fair and just solutions. However, the lack of a
            centralized system to document, monitor, and analyze land dispute cases limits the ability of advocacy groups to organize evidence,
            influence policy, and respond effectively to community needs.
          </p>
          <p>
            Many land conflicts in Timor-Leste are rooted in historical injustices. During Portuguese and Indonesian colonial rule,
            rural communities were often forcibly displaced and lost access to their traditional lands. These injustices have continued into
            the post-independence period, leading many communities to resist exploitation and reclaim lands from which they were previously evicted.
          </p>
          <p>
            To address these challenges, Kdadalak Sulimutuk Institute is working with rural communities and allied organizations to strengthen
            collective advocacy on land rights. A key step is improving the collection and management of accurate data on land disputes. For this purpose,
            KSI and its partners are developing an online platform to document and track land conflict cases.
          </p>
          <p>
            This platform will improve transparency, support evidence-based advocacy, and provide civil society, legal advocates, and
            community leaders with a tool to monitor cases and mobilize action to defend land rights in Timor-Leste.
          </p>
          <p>
            <a href="#long-en" onClick={e => { e.preventDefault(); setExpanded(true); }}>
              Read the long version &darr;
            </a>
          </p>
        </>
      ) : (
        <>
          <p>
            Land disputes remain a significant challenge in many regions of Timor-Leste, particularly affecting rural and marginalized
            communities. Civil society and advocacy organizations play a critical role in supporting fair and just resolutions to these
            disputes. However, the absence of a centralized system to record, monitor, and analyze land conflict cases has limited the
            ability of these organizations to systematically organize evidence, advocate for policy change, and provide timely support to
            affected communities.
          </p>
          <p>
            Land conflicts in Timor-Leste are deeply rooted in historical processes. During the Portuguese and Indonesian colonial periods,
            many rural communities lost access to their traditional lands through forced displacement and unjust land appropriation. These
            historical injustices have continued to influence land tenure issues even in the post-independence period. As a result, many
            rural communities have organized resistance against ongoing oppression and exploitation, including protests and the occupation
            of lands from which they were previously evicted.
          </p>
          <p>
            To respond to these challenges, Kdadalak Sulimutuk Institute (KSI) is working with rural communities and allied organizations
            to support transformative approaches to land justice. One key effort focuses on strengthening the technical capacity to collect
            and manage accurate data on land disputes. Reliable information is essential to support collective advocacy, strengthen
            community organizing, and influence policy reforms that protect the rights of rural populations.
          </p>
          <p>
            As part of this effort, KSI collaborates with other concerned allies who are actively engaged in land rights issues. Together,
            they are developing an online platform dedicated to documenting and tracking land dispute cases for advocacy purposes. This
            platform will serve as a centralized database to record cases, monitor their progress, and generate evidence-based analysis.
          </p>
          <p>
            By improving transparency and access to information, the platform will support data-driven advocacy and provide civil society
            organizations, legal advocates, and community representatives with a practical tool to monitor cases, coordinate responses,
            and mobilize resources to address land conflicts. Ultimately, this initiative aims to strengthen collective efforts to defend
            land rights and promote more equitable land governance in Timor-Leste.
          </p>
          <p>
            <a href="#short-en" onClick={e => { e.preventDefault(); setExpanded(false); }}>
              Read the short version &uarr;
            </a>
          </p>
        </>
      )}
      <Button color='teal' as={Link} to='/map'>
        Explore the map
      </Button>
    </TabPane>
  );
};

const TetumPane = () => {
  const [expanded, setExpanded] = useState(false);
  return (
    <TabPane attached={false}>
      <h5>Mapeamentu Konflitu Rai iha Timor-Leste</h5>
      {!expanded ? (
        <>
          <p>
            Konflitu rai kontinua sai dezafiu boot iha Timor-Leste, liu-liu ba komunidade rurál no grupu marginalizadu sira.
            Organizasaun sosiedade sivíl iha papél importante atu advoga solusaun ne'ebé justu no justisa ba konflitu sira ne'e.
            Maibé, falta plataforma sentralizadu ida atu dokumenta, monitoriza no analiza kazu konflitu rai limita kapasidade
            grupu advokasia sira atu organiza evidénsia, influénsia politika públika, no responde ho efetivu ba nesesidade komunidade sira.
          </p>
          <p>
            Konflitu rai barak iha Timor-Leste iha raiz iha injustisa istórika. Durante períodu kolonial Portugés no Indonézia, komunidade
            rurál barak hasoru dezlokamentu forsada no lakon asesu ba rai tradisionál sira. Injustisa sira ne'e kontinua influensia situasaun
            rai to'o períodu depois independénsia, ne'ebé hamosu rezisténsia husi komunidade sira hasoru eksplorasaun no esforsu atu rekopera rai
            ne'ebé mak hasai sira ho forsa.
          </p>
          <p>
            Atu responde ba dezafiu sira ne'e, KSI servisu hamutuk ho komunidade rurál no organizasaun aliadu sira atu reforsa advokasia
            kolektivu kona-ba direitu rai. Passu importante ida mak hadi'a prosesu koleta no jestaun dadus loos kona-ba konflitu rai. Tanba ne'e,
            KSI no parseiru sira dezenvolve hela plataforma online ida atu dokumenta no akompaña kazu konflitu rai.
          </p>
          <p>
            Plataforma ida ne'e sei aumenta transparénsia, suporta advokasia bazeia ba evidénsia, no fó instrumentu ba organizasaun sosiadade sivíl,
            advogadu legal, no lider komunidade sira atu monitoriza kazu sira no mobiliza asaun atu defende direitu rai iha Timor-Leste.
          </p>
          <p>
            <a href="#long-tet" onClick={e => { e.preventDefault(); setExpanded(true); }}>
              Lee versaun naruk &darr;
            </a>
          </p>
        </>
      ) : (
        <>
          <p>
            Konflitu rai kontinua sai dezafiu boot iha rejiaun barak iha Timor-Leste, liu-liu afeta komunidade rurál no grupu marginalizadu
            sira. Organizasaun sosiadade sivíl no organizasaun advokasia iha papél importante atu apoia rezolusaun ne'ebé justu no ekitativu
            ba konflitu sira ne'e. Maibé, falta sistema sentralizadu ida atu rejista, monitoriza no analiza kazu konflitu rai limita kapasidade
            organizasaun sira atu organiza evidénsia ho forma sistemátika, influensia politika públika no fó apoiu tempu loos ba komunidade
            afetadu sira.
          </p>
          <p>
            Konflitu rai iha Timor-Leste iha raiz iha prosesu istóriku. Durante períodu kolonial Portugés no Indonézia, komunidade rurál
            barak lakon asesu ba rai tradisionál tanba dezlokamentu forsada no apropriasaun rai ne'ebé la justu. Injustisa istórika sira
            ne'e kontinua influensia problema pose rai to'o períodu depois independénsia. Tanba ne'e, komunidade rurál barak organiza
            rezisténsia hasoru opresaun no eksplorasaun kontinua, inklui protestu no okupasaun rai ne'ebé sira hasai ho forsa iha tempu uluk.
          </p>
          <p>
            Atu responde ba dezafiu sira ne'e, Kdadalak Sulimutuk Institute (KSI) servisu hamutuk ho komunidade rurál no organizasaun aliadu
            sira atu promove abordajen transformativu ba justisa rai. Esforsu importante ida mak reforsa kapasidade téknika atu koleta no jere
            dadus loos kona-ba konflitu rai. Informasaun ne'ebé konfiável importante tebes atu suporta advokasia kolektiva, reforsa organizasaun
            komunidade no influensia reforma politika atu proteje direitu populasaun rurál sira.
          </p>
          <p>
            Nudar parte husi esforsu ida ne'e, KSI kolabora ho aliadu seluk ne'ebé iha kompromisu atu defende direitu rai. Hamutuk sira
            dezenvolve hela plataforma online ida atu dokumenta no akompaña kazu konflitu rai ba objetivu advokasia. Plataforma ida ne'e sei
            funsiona hanesan baze dadus sentralizadu atu rejista kazu sira, monitoriza progresu kazu sira no produz analiza bazeia ba evidénsia.
          </p>
          <p>
            Ho hadi'a transparénsia no asesu ba informasaun, plataforma ida ne'e sei suporta advokasia bazeia ba dadus no fó instrumentu
            prátiku ba organizasaun sosiadade sivíl, advogadu legal no reprezentante komunidade sira atu monitoriza kazu, koordena resposta
            no mobiliza rekursu atu responde ba konflitu rai. Iha ikus, inisiativa ida ne'e hakarak reforsa esforsu kolektivu atu defende
            direitu rai no promove governasaun rai ne'ebé liu justu no ekitativu iha Timor-Leste.
          </p>
          <p>
            <a href="#short-tet" onClick={e => { e.preventDefault(); setExpanded(false); }}>
              Lee versaun badak &uarr;
            </a>
          </p>
        </>
      )}
      <Button color='teal' as={Link} to='/map'>
        Explore the map
      </Button>
    </TabPane>
  );
};

const PortuguesePane = () => {
  const [expanded, setExpanded] = useState(false);
  return (
    <TabPane attached={false}>
      <h5>Mapeamento de Conflitos de Terra em Timor-Leste</h5>
      {!expanded ? (
        <>
          <p>
            Os conflitos de terra continuam a ser um grande desafio em Timor-Leste, especialmente para as comunidades rurais e marginalizadas.
            As organizações da sociedade civil desempenham um papel importante na defesa de soluções justas para esses conflitos. No entanto,
            a ausência de um sistema centralizado para documentar, monitorar e analisar os casos limita a capacidade das organizações de organizar
            evidências, influenciar políticas públicas e responder de forma eficaz às necessidades das comunidades.
          </p>
          <p>
            Muitos conflitos de terra em Timor-Leste têm origem em injustiças históricas. Durante os períodos coloniais português e indonésio,
            muitas comunidades rurais foram deslocadas à força e perderam o acesso às suas terras tradicionais. Essas injustiças continuaram a
            influenciar a situação da terra no período pós-independência, levando comunidades a resistir à exploração e a reivindicar terras das
            quais foram expulsas.
          </p>
          <p>
            Para enfrentar esses desafios, a KSI trabalha em conjunto com comunidades rurais e organizações aliadas para fortalecer a advocacia
            coletiva pelos direitos à terra. Um passo fundamental é melhorar a coleta e a gestão de dados precisos sobre os conflitos de terra.
            Para isso, a KSI e seus parceiros estão desenvolvendo uma plataforma online para documentar e acompanhar os casos de conflitos de terra.
          </p>
          <p>
            Essa plataforma irá promover maior transparência, apoiar a advocacia baseada em evidências e fornecer uma ferramenta para que organizações
            da sociedade civil, defensores legais e líderes comunitários possam monitorar os casos e mobilizar ações para proteger os direitos à terra em
            Timor-Leste.
          </p>
          <p>
            <a href="#long-pt" onClick={e => { e.preventDefault(); setExpanded(true); }}>
              Ver a versão longa &darr;
            </a>
          </p>
        </>
      ) : (
        <>
          <p>
            Os conflitos de terra continuam a ser um grande desafio em várias regiões de Timor-Leste, afetando especialmente as comunidades
            rurais e marginalizadas. Organizações da sociedade civil e de advocacia desempenham um papel fundamental no apoio à busca de
            soluções justas para esses conflitos. No entanto, a ausência de um sistema centralizado para registrar, monitorar e analisar
            casos de conflitos de terra tem limitado a capacidade dessas organizações de organizar evidências de forma sistemática, influenciar
            políticas públicas e prestar apoio oportuno às comunidades afetadas.
          </p>
          <p>
            Os conflitos de terra em Timor-Leste estão profundamente enraizados em processos históricos. Durante os períodos coloniais
            português e indonésio, muitas comunidades rurais perderam o acesso às suas terras tradicionais devido a deslocamentos forçados
            e à apropriação injusta de terras. Essas injustiças históricas continuam a influenciar as questões de posse da terra mesmo após
            a independência. Como resultado, muitas comunidades rurais têm organizado formas de resistência contra a opressão e exploração
            contínuas, incluindo protestos e a ocupação de terras das quais foram anteriormente expulsas.
          </p>
          <p>
            Para responder a esses desafios, o Kdadalak Sulimutuk Institute (KSI) trabalha em conjunto com comunidades rurais e organizações
            aliadas para apoiar abordagens transformadoras de justiça fundiária. Um dos principais esforços concentra-se no fortalecimento da
            capacidade técnica para coletar e gerir dados precisos sobre disputas de terra. Informações confiáveis são essenciais para apoiar
            a advocacia coletiva, fortalecer a organização comunitária e influenciar reformas políticas que protejam os direitos das populações
            rurais.
          </p>
          <p>
            Como parte desse esforço, o KSI colabora com outros aliados comprometidos com a defesa dos direitos à terra. Juntos, estão a
            desenvolver uma plataforma online dedicada à documentação e ao acompanhamento de casos de conflitos de terra para fins de advocacia.
            Esta plataforma funcionará como uma base de dados centralizada para registrar casos, monitorar o seu progresso e gerar análises
            baseadas em evidências.
          </p>
          <p>
            Ao melhorar a transparência e o acesso à informação, a plataforma apoiará a advocacia baseada em dados e fornecerá às organizações
            da sociedade civil, defensores legais e representantes comunitários uma ferramenta prática para monitorar casos, coordenar respostas
            e mobilizar recursos para enfrentar os conflitos de terra. Em última análise, esta iniciativa visa fortalecer os esforços coletivos
            para defender os direitos à terra e promover uma governação fundiária mais justa e equitativa em Timor-Leste.
          </p>
          <p>
            <a href="#short-pt" onClick={e => { e.preventDefault(); setExpanded(false); }}>
              Ver a versão curta &uarr;
            </a>
          </p>
        </>
      )}
      <Button color='teal' as={Link} to='/map'>
        Explorar o mapa
      </Button>
    </TabPane>
  );
};

const panes = [
  { menuItem: 'English', render: () => <EnglishPane /> },
  { menuItem: 'Tetum', render: () => <TetumPane /> },
  { menuItem: 'Português', render: () => <PortuguesePane /> },
];

const Panes = () => {
  const { state } = useContext(UserContext);

  return (
    <Tab menu={{ pointing: true }} loggedIn={state.loggedIn} panes={panes} />
  );
};

export default Panes;
